export const APIEncryptor = {
  enbledEncrypt: true,
  enbledDecrypt: true,
  key: "0123456789ASDFGH",
  iv: "ASDFGH0123456789",
};

// 7379743D89F96D514AF4F04B028BEDFE
// 0123456789ASDFGH
